import { render, staticRenderFns } from "./BsTabs.vue?vue&type=template&id=5c1ecdc3&scoped=true&lang=html&"
import script from "./BsTabs.vue?vue&type=script&lang=js&"
export * from "./BsTabs.vue?vue&type=script&lang=js&"
import style0 from "./BsTabs.vue?vue&type=style&index=0&id=5c1ecdc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1ecdc3",
  null
  
)

export default component.exports